<template></template>

<script>
  import store from '@/lib/store'
  import installPusher from '@/plugins/pusher'
  import { trimStart } from 'lodash'

  export default {
    props: ['recipient'],
    computed: {
      channelName () {
        const userId = store.get('user').id
        const phoneNumber = trimStart(this.recipient, '+')
        return `private-message.${userId}.${phoneNumber}`
      }
    },
    created () {
      installPusher()

      const channel = this.$pusher.subscribe(this.channelName)

      channel.bind('sms.received', payload => this.$emit('received', payload.activity))
      channel.bind('sms.sent', payload => this.$emit('sent', payload.activity))
      channel.bind('sms.delivered', payload => this.$emit('delivered', payload.activity))
      channel.bind('sms.failed', payload => this.$emit('failed', payload.activity))
      channel.bind('sms.undelivered', payload => this.$emit('undelivered', payload.activity))
    },
    beforeDestroy () {
      this.$pusher.unsubscribe(this.channelName)
    }
  }
</script>



// WEBPACK FOOTER //
// pusher-event-handlers.vue?51a760c8